import type { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';

export const sankeyChartDescription: CalculatorDescription = {
  id: CalculatorId.SankeyChart,
  title: 'Sankey Diagram Maker',
  metaTitle: 'Online Sankey Diagram Maker - Create Flow Charts',
  description: 'Create professional Sankey diagrams to visualize flow relationships and quantity distributions. Perfect for displaying energy flows, budget allocations, and process flows.',
  metaDescription: 'Make professional Sankey diagrams online. Visualize flows and distributions with our free Sankey diagram generator. Perfect for energy flows, budget allocations, and process analysis.',
  howTo: {
    title: 'How to Create a Sankey Diagram',
    steps: [
      'Enter flow data with path notation (e.g., Source->Process->Target)',
      'Add values for flow quantities',
      'Choose orientation (horizontal or vertical)',
      'Configure label display options',
      'Set title and finalize visualization'
    ],
    graphic: {
      description: 'An echarts Sankey diagram with interactive flows, proportional links, and flow quantity visualization'
    }
  },
  examples: [
    {
      title: 'Budget Flow Analysis',
      description: 'Financial allocation tracking',
      dataDescription: 'Revenue distribution across departments and activities',
      insights: [
        'Track revenue allocation',
        'Visualize cost distribution',
        'Identify major expenses',
        'Analyze budget efficiency'
      ]
    },
    {
      title: 'Energy Flow Analysis',
      description: 'Energy transfer visualization',
      dataDescription: 'Energy distribution across systems and processes',
      insights: [
        'Track energy transfers',
        'Identify energy losses',
        'Optimize system efficiency',
        'Analyze resource usage'
      ]
    }
  ],
  relatedCalculators: [
    CalculatorId.TreeChart,
    CalculatorId.SunburstChart,
    CalculatorId.BarGraph,
    CalculatorId.PieChart
  ]
}; 